import React from 'react';
import {HouseType as HouseTypeEnum} from "../config/enums";
import {houseTypesOptions} from "../config/options";

interface HouseTypeProps {
    houseType: HouseTypeEnum;
}

const HouseType = (props: HouseTypeProps) => {
    const type = houseTypesOptions.filter(f => f.key === props.houseType)[0];
    return <div id={'viewer'} className={'image-view'} style={{backgroundImage: `url(${type.srcBig})`}}>
        <p>{type.name}</p>
    </div>;
}

export default HouseType;